import adaptiveContentDark from './images/adaptive-content-dark.svg';
import adaptiveContentLight from './images/adaptive-content-light.svg';
import aiAssistantDark from './images/ai-assistant-dark.svg';
import aiAssistantLight from './images/ai-assistant-light.svg';
import authenticatedAccessDark from './images/authenticated-access-dark.svg';
import authenticatedAccessLight from './images/authenticated-access-light.svg';
import collaborationDark from './images/collaboration-dark.svg';
import collaborationLight from './images/collaboration-light.svg';
import customizationDark from './images/customization-dark.svg';
import customizationLight from './images/customization-light.svg';
import siteSectionsDark from './images/site-sections-dark.svg';
import siteSectionsLight from './images/site-sections-light.svg';

export const trialAssets = {
    aiAssistant: {
        light: aiAssistantLight,
        dark: aiAssistantDark,
    },
    collaboration: {
        light: collaborationLight,
        dark: collaborationDark,
    },
    customize: {
        light: customizationLight,
        dark: customizationDark,
    },
    siteSections: {
        light: siteSectionsLight,
        dark: siteSectionsDark,
    },
    authenticatedAccess: {
        light: authenticatedAccessLight,
        dark: authenticatedAccessDark,
    },
    adaptiveContent: {
        light: adaptiveContentLight,
        dark: adaptiveContentDark,
    },
} as const;
